/** What the signer is being asked to do for each Open Payments scaStatus. */
export function scaStatusExplanation(status: string | null | undefined): string {
    switch (status) {
        case "received":
            return "The bank has received the signing request. You have not signed the payment yet.";
        case "psuIdentified":
            return "The bank has identified you. You have not signed the payment yet.";
        case "psuAuthenticated":
            return "You are logged in at the bank. You have not signed the payment yet.";
        case "scaMethodSelected":
            return "The bank has chosen how you will sign, for example BankID. You have not signed the payment yet.";
        case "authenticationStarted":
            return "Scan the QR code to log in with BankID. This login does not sign the payment.";
        case "started":
            return "Signing of the payment has started. Scan the QR code to approve the payment.";
        case "finalised":
            return "Signing is complete. The payment has been approved.";
        case "failed":
            return "Signing failed. The payment was not approved.";
        case "exempted":
            return "The bank did not require a signature for this payment.";
        case "authoriseCreditorAccountStarted":
            return "The account is not a registered payment recipient. Scanning the QR code would add it as a payment recipient. That is blocked.";
        default:
            return "The bank has not reported what this signature is for yet.";
    }
}

/** True when the bank is asking the user to register a new payment recipient. */
export function isUnregisteredPaymentRecipientStatus(status: string | null | undefined): boolean {
    return status === "authoriseCreditorAccountStarted";
}
